import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import Navbar from './Navbar/Navbar';
import DropdownButton from './DropdownButton/DropdownButton';
import { useTranslation } from 'react-i18next';
import Sidebar from './Sidebar/Sidebar';
import channelService from "../../Services/channelService";
import "./Header.css"

const Header = () => {
    const [show, setShow] = useState(false);
    const [channelList, setChannelList] = useState([]);

    const { t } = useTranslation();

    useEffect(() => {
        (async () => {
            try {
                const response = await channelService.getChannel();
                setChannelList(response);
            } catch (error) {
                console.error("Errore nel recupero del channel:", error);
            }
        })();
    }, []);

    const toggleSidebar = () => {
        setShow(prevState => !prevState);
    }

    return (
        <>
            <div className="d-flex flex-column justify-content-center align-items-center costa-header text-uppercase">
                <div className="header-items container fluid">
                    <div className="costa-header-top container">
                        <div className="header-top-items d-flex flex-row align-items-center">
                            <Link to="/" className='text-decoration-none header-link'>{t('press_center')}</Link>
                            <DropdownButton channelList={channelList} />
                        </div>
                    </div>
                    <Navbar showSidebar={toggleSidebar} />
                </div>
            </div>
            <Sidebar showMenu={show} channelList={channelList} />
        </>
    )
}

export default Header